import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import * as Icons from "lucide-react";
import { ChevronDown, ChevronRight } from "lucide-react";
import useAuth from "../../hooks/useAuth";

const Sidebar = ({ isSidebarOpen, version }) => {
  const location = useLocation();
  const { auth } = useAuth();
  const [openMenu, setOpenMenu] = useState(null);

  const getIcon = (iconName, size = 18) => {
    const IconComponent = Icons[iconName];
    return IconComponent ? <IconComponent size={size} /> : null;
  };

  const toggleMenu = (name) => {
    setOpenMenu(openMenu === name ? null : name);
  };

  const menuItems = auth.menus || []; // 👈 ya viene filtrado desde el login, sin fetch propio

  return (
    <div
      className={`sidebar-gradient text-white w-full lg:w-64 p-5 flex flex-col justify-between h-full shadow-lg ${
        isSidebarOpen ? "block" : "hidden"
      }`}
    >
      <div>
        <h2 className="text-2xl text-center font-bold mb-6 tracking-wide">MENÚ</h2>

        <ul className="space-y-2">
          {menuItems.map((item) => {
            const isActive = location.pathname === item.path;
            const isOpen = openMenu === item.name;

            return (
              <li key={item.name}>
                {item.children && item.children.length > 0 ? (
                  <>
                    <button
                      onClick={() => toggleMenu(item.name)}
                      className={`flex items-center justify-between w-full p-3 rounded-lg transition-all duration-300 shadow-sm ${
                        isOpen ? "menu-item active shadow-md" : "menu-item hover:shadow-md"
                      }`}
                    >
                      <div className="flex items-center gap-3">
                        {getIcon(item.icon)}
                        <span className="text-sm font-medium">{item.name}</span>
                      </div>
                      {isOpen ? <ChevronDown size={16} /> : <ChevronRight size={16} />}
                    </button>

                    <ul
                      className={`ml-8 overflow-hidden transition-all duration-300 ease-in-out ${
                        isOpen ? "max-h-40 opacity-100 mt-2" : "max-h-0 opacity-0"
                      }`}
                    >
                      {item.children.map((sub) => {
                        const isSubActive = location.pathname === sub.path;
                        return (
                          <li key={sub.name}>
                            <Link
                              to={sub.path}
                              className={`flex items-center gap-2 p-2 rounded-md text-sm transition-all ${
                                isSubActive ? "menu-item active shadow-md" : "menu-item hover:shadow-md"
                              }`}
                            >
                              {getIcon(sub.icon, 16)}
                              {sub.name}
                            </Link>
                          </li>
                        );
                      })}
                    </ul>
                  </>
                ) : (
                  <Link
                    to={item.path}
                    className={`flex items-center gap-3 p-3 rounded-lg transition-all duration-300 shadow-sm ${
                      isActive ? "menu-item active shadow-md" : "menu-item hover:shadow-md"
                    }`}
                  >
                    {getIcon(item.icon)}
                    <span className="text-sm font-medium">{item.name}</span>
                  </Link>
                )}
              </li>
            );
          })}
        </ul>
      </div>

      <h6 className="text-gray-300 text-xs text-center mt-4 italic">
        {`Ags Solutions · Versión: ${version}`}
      </h6>
    </div>
  );
};

export default Sidebar;